var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHackernews = function SvgHackernews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64,
    viewBox: "0 0 430.117 430.118"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0v430.118h430.117V0zm234.175 248.167v105.485h-38.232V248.167L101.985 62.128h44.265l68.713 140.07 71.446-140.07h41.499z"
  })));
};
export default SvgHackernews;